/* Shared, read-only Shopify search. Result requests never navigate the page. */
(() => {
  if (window.__vivilandSearchPopover) return;
  window.__vivilandSearchPopover = true;
  const dialog = document.querySelector('#vv-search-dialog');
  if (!dialog) return;
  const input = dialog.querySelector('#vv-search-input');
  const results = dialog.querySelector('#vv-search-results');
  const collections = dialog.querySelector('#vv-search-collection-results');
  const status = dialog.querySelector('[data-search-status]');
  const retry = dialog.querySelector('[data-search-retry]');
  const clear = dialog.querySelector('[data-search-clear]');
  const intro = dialog.querySelector('[data-search-intro]');
  const scrollPanel = dialog.querySelector('.vv-search-scroll');
  const header = document.querySelector('[data-vv-header],#shopify-section-viviland-home-header > .header');
  const searchUrl = new URL(dialog.dataset.searchUrl, location.origin);
  let opener, anchor, scrollState, debounce, request, version = 0, activeQuery = '', moreUrl = '', failedPage = null, composing = false;
  const visible = node => node && node.getClientRects().length > 0;
  function lockScroll() {
    if (scrollState) return;
    const section = header.closest('.shopify-section');
    scrollState = {y: scrollY, body: {}, header: {}, overflow: document.documentElement.style.overflow, section, sectionHeight: section.style.height};
    for (const key of ['position','top','left','right','width','overflow']) scrollState.body[key] = document.body.style[key];
    for (const key of ['position','top','left','width','margin','transition']) scrollState.header[key] = header.style[key];
    const rect = header.getBoundingClientRect();
    scrollState.viewportWidth = innerWidth;
    scrollState.headerTop = rect.top;
    section.style.height = `${section.offsetHeight}px`;
    Object.assign(header.style, {position:'fixed',top:`${rect.top}px`,left:`${rect.left}px`,width:`${rect.width}px`,margin:'0',transition:'none'});
    Object.assign(document.body.style,{position:'fixed',top:`-${scrollState.y}px`,left:'0',right:'0',width:'100%',overflow:'hidden'});
    document.documentElement.style.overflow = 'hidden';
  }
  function unlockScroll() {
    if (!scrollState) return;
    const saved = scrollState; scrollState = null;
    const behavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    Object.assign(document.body.style,saved.body);
    Object.assign(header.style,saved.header);
    saved.section.style.height = saved.sectionHeight;
    document.documentElement.style.overflow = saved.overflow;
    window.scrollTo(0,saved.y);
    document.documentElement.style.scrollBehavior = behavior;
  }
  function position() {
    if (!dialog.open) return;
    if (scrollState && scrollState.viewportWidth !== innerWidth) {
      // Re-measure the header at its natural width after an orientation/viewport change.
      Object.assign(header.style,scrollState.header);
      header.style.transition='none';
      scrollState.section.style.height=scrollState.sectionHeight;
      const resized=header.getBoundingClientRect();
      scrollState.section.style.height=`${scrollState.section.offsetHeight}px`;
      Object.assign(header.style,{position:'fixed',top:`${scrollState.headerTop}px`,left:`${resized.left}px`,width:`${resized.width}px`,margin:'0',transition:'none'});
      scrollState.viewportWidth=innerWidth;
    }
    if (!visible(anchor)) anchor = [...document.querySelectorAll('[data-vv-search-open]')].find(visible);
    const rect = (anchor || header).getBoundingClientRect();
    const viewportTop = window.visualViewport?.offsetTop || 0;
    const viewportHeight = window.visualViewport?.height || innerHeight;
    const bottom = viewportTop + viewportHeight;
    const top = Math.max(viewportTop + 12,Math.min(header.getBoundingClientRect().bottom + 8,bottom - 240));
    const left = innerWidth <= 700 ? 16 : Math.max(16,Math.min(rect.left,innerWidth-dialog.offsetWidth-16));
    dialog.style.top = `${top}px`;
    dialog.style.left = `${left}px`;
    dialog.style.right = 'auto';
    dialog.style.maxHeight = `${Math.max(180,bottom-top-16)}px`;
    dialog.style.setProperty('--search-origin-x',`${rect.left+rect.width/2-left}px`);
    dialog.style.setProperty('--search-origin-y',`${rect.top+rect.height/2-top}px`);
  }
  function cancelRequest() {
    clearTimeout(debounce);
    version++;
    request?.abort();
    dialog.removeAttribute('aria-busy');
  }
  function resetResults() {
    cancelRequest(); activeQuery=''; moreUrl=''; failedPage=null;
    results.replaceChildren();collections.replaceChildren();status.textContent='';status.classList.remove('is-error');retry.hidden=true;intro.hidden=false;clear.hidden=true;
  }
  function close() {
    cancelRequest();dialog.classList.remove('is-open');dialog.close();
  }
  function open(trigger) {
    if (dialog.open) return;
    opener = trigger;
    anchor = trigger.matches('[data-vv-search-open]') ? trigger : [...document.querySelectorAll('[data-vv-search-open]')].find(visible);
    for (const other of document.querySelectorAll('dialog[open]')) {
      const closeButton = other.querySelector('.menu-close,.bag-close,[data-vv-close]');
      if (closeButton) closeButton.click(); else other.close();
    }
    lockScroll();dialog.showModal();position();
    document.querySelectorAll('[data-vv-search-open]').forEach(node=>node.setAttribute('aria-expanded','true'));
    // Establish the collapsed frame before starting the same bubble animation as the bag.
    dialog.getBoundingClientRect();
    requestAnimationFrame(()=>{if(dialog.open)dialog.classList.add('is-open');});
    input.focus({preventScroll:true});
    if(input.value.trim()) search();
  }
  async function search(pageUrl = null, focusNew = false) {
    const query = input.value.trim();
    if(!query){resetResults();return;}
    cancelRequest();
    const id = version;
    const append = !!pageUrl && query === activeQuery;
    const url = new URL(pageUrl || searchUrl, location.origin);
    if(url.origin !== location.origin || url.pathname !== searchUrl.pathname) return;
    url.searchParams.set('q',query);url.searchParams.set('type','product');url.searchParams.set('options[prefix]','last');url.searchParams.set('view','viviland-popover');
    if(!append){url.searchParams.delete('page');results.replaceChildren();collections.replaceChildren();scrollPanel.scrollTop=0;moreUrl='';}
    activeQuery=query;failedPage=null;retry.hidden=true;intro.hidden=true;clear.hidden=false;
    status.classList.remove('is-error','vv-search-sr');status.textContent=dialog.dataset.searchLoading;dialog.setAttribute('aria-busy','true');
    const controller=new AbortController();request=controller;
    const timer=setTimeout(()=>controller.abort(),12000);
    try {
      const collectionRequest = async () => {
        if(append)return null;
        const categoryUrl=new URL(dialog.dataset.collectionSearchUrl,location.origin);
        categoryUrl.searchParams.set('q',query);
        categoryUrl.searchParams.set('resources[type]','collection');
        categoryUrl.searchParams.set('resources[limit]','10');
        categoryUrl.searchParams.set('section_id','viviland-search-collections');
        try {
          const response=await fetch(categoryUrl,{credentials:'same-origin',cache:'no-store',signal:controller.signal});
          if(!response.ok)throw new Error('Collection search unavailable');
          const html=new DOMParser().parseFromString(await response.text(),'text/html');
          const found=html.querySelector('[data-vv-search-collection-response]');
          if(!found || !/^\d+$/.test(found.dataset.count))throw new Error('Collection response missing');
          return found;
        }catch{return null;}
      };
      const [response,categoryMatches]=await Promise.all([
        fetch(url,{credentials:'same-origin',cache:'no-store',signal:controller.signal}),collectionRequest()
      ]);
      if(!response.ok)throw new Error('Search response unavailable');
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      if(id!==version || !dialog.open)return;
      const fresh=html.querySelector('[data-vv-search-response]');
      if(!fresh || !/^\d+$/.test(fresh.dataset.count))throw new Error('Search response missing');
      if(!append && categoryMatches)collections.replaceChildren(categoryMatches);
      const next=fresh.querySelector('[data-search-more]');
      moreUrl=next?.getAttribute('href') || '';
      if(append){
        const list=results.querySelector('[data-search-products]');
        const freshRows=[...fresh.querySelectorAll('[data-search-products]>li')];
        if(!list)throw new Error('Search list missing');
        const first=freshRows[0];
        results.querySelector('[data-search-more]')?.remove();
        list.append(...freshRows);
        if(next)results.querySelector('[data-vv-search-response]').append(next);
        if(focusNew)first?.querySelector('a')?.focus({preventScroll:true});
      }else results.replaceChildren(fresh);
      status.textContent=[collections.querySelector('[data-summary]')?.dataset.summary,fresh.querySelector('[data-result-count]')?.textContent].filter(Boolean).join(' · ');
      // Keep one visible count, while the status still announces updated results.
      status.classList.add('vv-search-sr');
      if(!append && !categoryMatches){status.classList.remove('vv-search-sr');status.classList.add('is-error');status.textContent=dialog.dataset.collectionError;retry.hidden=false;}
    }catch(error){
      if(id!==version || !dialog.open)return;
      failedPage=append?pageUrl:null;status.classList.remove('vv-search-sr');status.classList.add('is-error');status.textContent=dialog.dataset.searchError;retry.hidden=false;
    }finally{
      clearTimeout(timer);controller.abort();
      if(id===version)dialog.removeAttribute('aria-busy');
    }
  }
  function changed() {
    cancelRequest();clear.hidden=!input.value;status.classList.remove('vv-search-sr');
    if(!input.value.trim()){resetResults();return;}
    results.replaceChildren();collections.replaceChildren();moreUrl='';retry.hidden=true;intro.hidden=true;status.textContent=dialog.dataset.searchLoading;
    if(!composing)debounce=setTimeout(()=>search(),350);
  }
  document.addEventListener('click',event=>{
    if(!(event.target instanceof Element))return;
    const trigger=event.target.closest('[data-vv-search-open]');
    const menuLink=event.target.closest('#mobile-menu a[href],#vv-menu-dialog a[href]');
    const isMenuSearch=menuLink && new URL(menuLink.href).pathname===searchUrl.pathname;
    if(!trigger&&!isMenuSearch)return;
    if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button!==0)return;
    event.preventDefault();open(trigger||menuLink);
  });
  dialog.querySelector('[data-search-close]').addEventListener('click',close);
  dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
  dialog.addEventListener('close',()=>{
    cancelRequest();dialog.classList.remove('is-open');unlockScroll();
    document.querySelectorAll('[data-vv-search-open]').forEach(node=>node.setAttribute('aria-expanded','false'));
    (visible(opener)?opener:anchor)?.focus({preventScroll:true});
  });
  input.addEventListener('input',changed);
  input.addEventListener('compositionstart',()=>{composing=true;cancelRequest();});
  input.addEventListener('compositionend',()=>{composing=false;changed();});
  clear.addEventListener('click',()=>{input.value='';resetResults();input.focus({preventScroll:true});});
  dialog.querySelector('form').addEventListener('submit',event=>{event.preventDefault();if(!composing)search();});
  retry.addEventListener('click',()=>search(failedPage));
  dialog.addEventListener('click',event=>{
    if(!(event.target instanceof Element))return;
    const term=event.target.closest('[data-search-term]');
    if(term){input.value=term.dataset.searchTerm;search();return;}
    const more=event.target.closest('[data-search-more]');
    if(more){event.preventDefault();if(dialog.getAttribute('aria-busy')!=='true'&&moreUrl)search(moreUrl,event.detail===0);return;}
    if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();}
  });
  dialog.addEventListener('keydown',event=>{
    if(event.key!=='Tab')return;
    const items=[...dialog.querySelectorAll('button:not(:disabled),input:not([type="hidden"]),a[href]')].filter(visible);
    if(event.shiftKey&&document.activeElement===items[0]){event.preventDefault();items.at(-1)?.focus();}
    else if(!event.shiftKey&&document.activeElement===items.at(-1)){event.preventDefault();items[0]?.focus();}
  });
  window.addEventListener('resize',position);
  window.visualViewport?.addEventListener('resize',position);
  window.visualViewport?.addEventListener('scroll',position);
  window.addEventListener('pagehide',()=>{if(dialog.open)close();unlockScroll();});
})();
